<template>
  <v-container fluid class="register">
    <v-layout justify-center wrap align-center>
      <v-flex xs12 sm6 md6 lg4 class="pr-1 mb-1" order-sm2 order-md2 order-xs1 order-lg1>
        <v-card>
          <v-card-text>
            <div>
              <h3>Personal Details</h3>
              <p>Enter your personal details</p>
              <p>If you want to have multiple accounts, e.g. Nurse &amp; Nutritionist, you will have to create multiple accounts, using different emails.</p>
              <p>The details you enter should be verifiable.</p>
              <p>Don't forget to upload your identification document, not more than 2MB</p>
            </div>
            <hr class="transparent">
            <div>
              <h3>Professional Details</h3>
              <p>Please upload your licence and registration for verification</p>
              <p>After verification, your account will be activated</p>
              <portal to="redirector">
                <p @click="goTo('/register')" role="button">
                  <v-checkbox label="I don't have these details. I'll add them later"></v-checkbox>
                </p>
              </portal>
              <portal-target name="redirector"></portal-target>
            </div>
            <hr class="transparent">
            <h3>Account</h3>
            <p>Add a username or leave blank to use your email. You have the opportunity to change your account details later</p>
            <p>The password should be at least 8 characters long, have a mix of uppercase and lowercase letters, numbers and symbols. Use a password manager to create a strong password if possible.</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md6 lg4 class="mb-1" order-sm1 order-md1 order-xs2 order-lg2>
        <v-card>
          <v-card-text>
            <create-pro-account :professions="professions" :diagnostic_kits="diagnostic_kits" :errors="errors"></create-pro-account>
          </v-card-text>
          <v-card-actions class="">
            &copy; 2021
            <v-spacer></v-spacer>
            <span v-html="$title"></span>
            <v-spacer></v-spacer>
            <v-btn text small href="/privacy-policy">Privacy Policy</v-btn>
            <v-btn text small href="/terms-of-use">Terms Of Use</v-btn>
            <!-- <a href="/privacy" title="Privacy Policy">Privacy</a>
            <a href="/terms" title="Terms of Use">Terms of Use</a> -->
          </v-card-actions>
        </v-card>
        <!-- <p class="text-center">This page is protected by Google's recaptcha. Google <a href="https://www.google.com/intl/en-GB/policies/privacy/" target="_blank" rel="noreferrer noopener">Privacy</a> and <a href="https://www.google.com/intl/en-GB/policies/terms/" target="_blank" rel="noreferrer noopener">Terms</a> apply.</p> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  const CreateProAccount =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "professionals" */ '@/Components/Professionals/create')
  import layout from '@/Layouts/Guest'

  export default {
    name: 'Register',
    layout,
    components: {
      CreateProAccount
    },
    props: [
      'professions', 'diagnostic_kits', 'errors'
    ],
    metaInfo () {
      return {
        title: 'Register',
        titleTemplate: '%s | ' + this.$title
      }
    },
  }
</script>

<style scoped>
  #awesome {
    position: absolute;
    height: 50vh;
    background: lightskyblue;
    width: -webkit-fill-available;
    margin-top: 0px;
  }
  .bg-info {
    background: lightskyblue !important;
  }
  .register {
    background: linear-gradient(45deg, rgba(9, 50, 40, 0.5), rgba(50,75,10,0.5)), url('/images/tablets.jpg');
    background-attachment: fixed;
    background-size: cover;
  }
</style>
